// extracted by mini-css-extract-plugin
export default {"container":"Error_container__Tvbwy","textContainer":"Error_textContainer__4lrN0","backButton":"Error_backButton__CUuQ3"};